import {
  getResponseByMode
} from './utils';

// eslint-disable-next-line spaced-comment
export const dadataToken = getResponseByMode('d2bb2e2a4c19c903bdf6302ce5279838825b4768', '2fea96f5ac652a320abe48a94e29aa175034bf62');
export const ENTER_KEY = 'Enter';
export const ESC_KEY = 'Escape';
export const RUBLE = ' руб.';
export const CAPTCHA_KEY = '6Lf-COkZAAAAACij46e8uzDFyKzBWUb6vFek9CZx';
export const DEBOUNCE_INTERVAL = 500;
export const MAX_TEXT_HEIGHT = 70;
export const MAP_URL = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;apikey=e905aeb6-0681-4b23-8339-cfab34655da2';
export const INPUT_COUNT_PER_STEP = 7;
export const CLASS_HIDE = 'uf_hide';
export const CLASS_DISABLES = 'uf_disabled';
export const CLASS_SELECTED = 'uf_label_selected';
export const TIMEOUT = 1000;
export const CategoryAction = {
  SORT: 'sort',
  FILTERS: 'filters',
  LOADMORE: 'loadmore'
};
export const MAX_MODELS = 50;
export const UpdateType = {
  LIGHT: 3,
  MEDIUM: 1,
  LARGE: 2
};
export const DELAY = 500;
export const SearchParams = {
  GOOD: ['query', 'start'],
  BAD: ['urlUnijaxFilter', 'uf_search_input_16']
};
export let paymentsState = {
  'id3': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': false,
  },
  'id10': {
    //'sber': false,
    'online': false,
    'bank': false,
    //'cash': true,
  },
  'id1': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': false,
  },
  'id13': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': true,
  },
  'id14': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': true,
  },
  'id11': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': false,
  },
  'id18': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': false,
  },
  'id19': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': true,
  },
  'id20': {
    //'sber': true,
    'online': true,
    'bank': true,
    //'cash': true,
  },

  setState(id, payment, bool) {
    this[id][payment] = bool;
  }
};
export const NULL_TEXT = '0' + RUBLE;
export const FREE_TEXT = 'Бесплатно';
export const DISABLE_CLS = ['disabled'];
export const DISABLE_SHOW_CLS = ['disabled', 'disabled--show'];
export const PREFIX = 'FixMobile_';
export const ZOOM = 8;
export const MIN_ZOOM = 9;
export const MAX_ZOOM = 15;
export const Company = {
  CDEK: 'СДЭК',
  ENERGY: 'ТК Энергия',
  OZON: 'OZON',
  POSTAMAT: 'Постамат',
};
export const FILTERS = {
  'Все': true,
  'СДЭК': true,
  'ТК Энергия': true,
  'OZON': true,
  'Постамат': true
};
export const SELECTPICKER_OPTION = {
  noneResultsText: 'Не найдено по запросу {0}',
  noneSelectedText: 'Ничего не выбрано',
  selectAllText: 'Выбрать всё',
  deselectAllText: 'Сбросить всё',
  size: 10
};
export const FIAS_ID = document.body.dataset.fiasId;
